// src/app/modules/Dashboard/_redux/dashboard/Slice.js
import { createSlice } from "@reduxjs/toolkit";

const initialDashboardState = {
  listLoading: false,
  actionsLoading: false,

  danger_zones: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const DashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialDashboardState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    stopLoading: (state) => {
      state.actionsLoading = false;
      state.listLoading = false;
    },
  
    dangerZonesFetched: (state, action) => {
      state.danger_zones = action.payload;
      state.listLoading = false;
    },
    dangerZoneAdded: (state, action) => {
      state.actionsLoading = false;
      // Prepend the new report to the local state for instant UI update
      state.danger_zones = [action.payload, ...state.danger_zones];
    },
    


  }
});